import { Email } from '@/services/shared-inbox/email.dto';

export default {
  SET_FILTERS_LIST(state, list) {
    state.list = list;
  },
};
